(()=>{
  const initCart=root=>{
    if(!root||root.dataset.akCartReady==='true')return;
    root.dataset.akCartReady='true';

    const form=root.querySelector('#AkCartForm');
    if(!form)return;

    const shopRoot=window.Shopify?.routes?.root||'/';
    const route=path=>`${shopRoot}${path}`.replace(/\/+/g,'/');
    const checkoutButton=form.querySelector('[data-ak-cart-checkout]');

    const collectUpdates=()=>{
      const updates={};
      root.querySelectorAll('[data-ak-cart-item]').forEach(item=>{
        const key=item.getAttribute('data-ak-line-key');
        const input=item.querySelector('.ak-cart-qty-input');
        if(!key||!input)return;
        const parsed=parseInt(input.value||'0',10);
        updates[key]=Number.isFinite(parsed)&&parsed>=0?parsed:0;
      });
      return updates;
    };

    const syncCart=async()=>{
      const response=await fetch(route('cart/update.js'),{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json',
          'X-Requested-With':'XMLHttpRequest'
        },
        credentials:'same-origin',
        body:JSON.stringify({updates:collectUpdates()})
      });
      if(!response.ok)throw new Error('cart sync failed');
      return response.json();
    };

    root.querySelectorAll('[data-ak-cart-item]').forEach(item=>{
      const input=item.querySelector('.ak-cart-qty-input');
      if(!input)return;

      item.querySelectorAll('[data-ak-cart-qty]').forEach(button=>{
        button.addEventListener('click',()=>{
          const current=Math.max(0,parseInt(input.value||'0',10)||0);
          const next=button.dataset.akCartQty==='plus'?current+1:Math.max(0,current-1);
          input.value=String(next);
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });

      input.addEventListener('change',()=>{
        const value=parseInt(input.value||'0',10);
        if(!Number.isFinite(value)||value<0)input.value='0';
      });
    });

    checkoutButton?.addEventListener('click',async event=>{
      event.preventDefault();
      if(checkoutButton.getAttribute('aria-busy')==='true')return;

      checkoutButton.setAttribute('aria-busy','true');
      checkoutButton.disabled=true;
      const originalLabel=checkoutButton.textContent;
      checkoutButton.textContent='OPENING SECURE CHECKOUT…';

      try{
        await syncCart();
        window.location.assign(route('checkout'));
      }catch(error){
        console.error('[AK cart checkout]',error);
        /* Never strand the shopper. If the AJAX sync fails, use Shopify's live cart session. */
        window.location.assign(route('checkout'));
        setTimeout(()=>{
          checkoutButton.disabled=false;
          checkoutButton.removeAttribute('aria-busy');
          checkoutButton.textContent=originalLabel;
        },1200);
      }
    });

    form.addEventListener('submit',event=>{
      const submitter=event.submitter;
      if(!submitter||submitter.name!=='update')return;
      submitter.setAttribute('aria-busy','true');
      submitter.textContent='UPDATING CART…';
      /* Native Shopify cart update remains the fallback/manual refresh path. */
    });
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-cart]').forEach(initCart);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  window.addEventListener('pageshow',()=>initAll(document));
})();
